var map = {
	"./smiley_0.svg": 42279,
	"./smiley_1.svg": 64835,
	"./smiley_10.svg": 60628,
	"./smiley_2.svg": 54201,
	"./smiley_3.svg": 13068,
	"./smiley_4.svg": 66640,
	"./smiley_5.svg": 37475,
	"./smiley_6.svg": 11568,
	"./smiley_7.svg": 53036,
	"./smiley_8.svg": 57997,
	"./smiley_9.svg": 13419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90744;